import React, {Component} from 'react';
import AUX from '../../hoc/Aux_';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import {pushUserId} from '../../actions/general';
import { connect } from 'react-redux';

const menuItems = [
   '',
   'kugi',
   'login'
];

class Header extends Component{

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      active: "",
      loginActive: localStorage.getItem('userID')

    }
  }

  componentWillMount(){
    //this.setState({loginActive: ""})
  }

    componentDidMount() {
        $('.navbar-toggle').on('click', function(event) {
            $(this).toggleClass('open');
            $('#navigation').slideToggle(400);
        });

        $('.navigation-menu>li').slice(-2).addClass('last-elements');

        $('.menu-arrow,.submenu-arrow, .menu-arrowx').on('click', function(e) {
            if ($(window).width() < 992) {
                e.preventDefault();
                $(this).parent('li').toggleClass('open').find('.submenu:first').toggleClass('open');
            }
        });
    }

    componentWillReceiveProps(nextProps){
      this.setState({loginActive: nextProps.userID})
    }

    _handleClick(menuItem) {
      if(menuItem == "login"){
        localStorage.clear();
        this.props.pushUserId("");

      }
      this.setState({ active: menuItem });

    }

    _handleClickLogout(menuItem) {

      localStorage.clear();
      this.props.pushUserId("");
      this.setState({ active: menuItem });
      window.location.replace("/");

    }

    renderLogin = ()=>{
      const activeStyle = { color: '#ffffff' };

      if(!this.state.loginActive){
        return (
          <ul className="navigation-menu ">
            <li className="has-submenu ">
                <Link
                style={this.state.active === "" ? activeStyle : {}}
                onClick={this._handleClick.bind(this, "")}
                to="">
                  Beranda
                </Link>
            </li>
            <li className="has-submenu">
                <Link to="#"
                style={this.state.active === "kugi" ? activeStyle : {}}
                onClick={this._handleClick.bind(this, "kugi")}
                className="menu-arrowx"
                >KUGI</Link>
                <span className="menu-arrow"/>
                <ul className="submenu " >
                    <li>
                        <Link to="/kugi" onClick={this._handleClick.bind(this, "kugi")}>KUGI Versi 5.1</Link>
                    </li>

                    <li>
                        <Link to="pencarianbig" onClick={this._handleClick.bind(this, "kugi")}>Pencarian Data KUGI</Link>
                    </li>
                    <li>
                        <Link to="/unduhbukukugi" onClick={this._handleClick.bind(this, "tautan")}>Unduh Buku KUGI</Link>
                    </li>
                    <li>
                        <Link to="/unduhtemplatekugi" onClick={this._handleClick.bind(this, "tautan")}>Unduh Template KUGI </Link>
                    </li>
                    <li className="has-submenu">
                        <a target="_blank" href="https://gold.big.go.id/pencarianobjek">Pencarian Dengan Ontology</a>
                    </li>
                </ul>
            </li>
    
            <li className="has-submenu">
                <Link to="#"
                style={this.state.active === "tautan" ? activeStyle : {}}
                onClick={this._handleClick.bind(this, "tautan")}
                className="menu-arrowx"
                >Tautan & Juknis</Link>
                <span className="menu-arrow"/>
                <ul className="submenu " >

                    
                    <li className="has-submenu">
                        <a target="_blank" href="https://tanahair.indonesia.go.id/portal-web">Ina Geo Portal</a>
                    </li>
                    <li className="has-submenu">
                        <a target="_blank" href="https://kugi.ina-sdi.or.id/buku/Peraturan/se-6-2021-big.pdf">SE Ka.BIG 6/2021 - Pedoman Standar Data dan Struktur dan Format Baku Metadata</a>
                    </li>
                    <li className="has-submenu">
                        <a target="_blank" href="https://kugi.ina-sdi.or.id/buku/Panduan/Pedoman-Kerangka-Integrasi-Spasial-Statistik-tek.pdf">Pedoman Kerangka Integrasi Spasial Statistik (Teknologi)</a>
                    </li>
                    <li className="has-submenu">
                        <a target="_blank" href="http://pesta.bsn.go.id/produk/detail/9864-sniiso191102015">SNI ISO 19110 - 2015</a>
                    </li>
                     <li className="has-submenu">
                        <a target="_blank" href="https://jdih.big.go.id/id/produk-hukum/3155">PerBIG No 12 Tahun 2013</a>
                    </li>
                    <li className="has-submenu">
                        <a target="_blank" href="https://kugi.ina-sdi.or.id/buku/Panduan/Pedoman%20Penyusunan%20Data%20Sesuai%20KUGI%20QGIS%20dan%20ArcGIS.pdf">Juknis Penyusunan Data Sesuai KUGI</a>
                    </li>
                    <li className="has-submenu">
                        <a>Juknis Pembuatan Metadata Geospasial</a>
                        <ul className="submenu " >
                        <li className="has-submenu">
                        <a target="_blank" href="https://kugi.ina-sdi.or.id/buku/Panduan/Petunjuk%20Implementasi%20Pembuatan%20Metadata%20v6.pdf">Juknis Pembuatan Metadata Menggunakan ArcCatalog</a>
                        </li>
                        <li className="has-submenu">
                        <a target="_blank" href="https://kugi.ina-sdi.or.id/buku/Panduan/Petunjuk%20Implementasi%20Pembuatan%20Metadata%20v3CATMD.pdf">Juknis Pembuatan Metadata Menggunakan CatMDEdit</a>
                        </li>
                        </ul>
                    </li>
                    <li className="has-submenu">
                        <a target="_blank" href="https://www.youtube.com/playlist?list=PLP-Vnnw3ny2ZrSrkcxG0ILMsXbPQbpAUp">Video Penyusunan Data Sesuai KUGI</a>
                    </li>
                    
                    <li className="has-submenu">
                        <a>Video Tutorial Pembuatan Metadata</a>
                        <ul className="submenu " >
                        <li className="has-submenu">
                        <a target="_blank" href="https://youtu.be/T4AdLS8O1ZE">Pengenalan Pentingnya Metadata Geospasial</a>
                        </li>
                        <li className="has-submenu">
                        <a target="_blank" href="https://www.youtube.com/watch?v=egrZwWeMBDo">Tutorial Pembuatan Metadata Menggunakan ArcCatalog</a>
                        </li>
                        <li className="has-submenu">
                        <a target="_blank" href="https://www.youtube.com/watch?v=tVjs2N9zVF8">Tutorial Pembuatan Metadata Menggunakan CatMDEdit</a>
                        </li>
                        </ul>
                    </li>
                </ul>
            </li>


            <li>
                <a href = "https://documenter.getpostman.com/view/11245272/Tz5ncdvS" target="_blank">Layanan API</a>
            </li>
           <li className="has-submenu">
                <Link to="#"
                style={this.state.active === "Standar Layanan" ? activeStyle : {}}
                onClick={this._handleClick.bind(this, "Standar Layanan")}
                className="menu-arrowx"
                >Standar Layanan</Link>
                <span className="menu-arrow"/>
                <ul className="submenu " >
                    <li className="has-submenu">
                        <a target="_blank" href="https://kugi.ina-sdi.or.id/tentang">Tentang Layanan KUGI</a>
                    </li>
                    <li className="has-submenu">
                        <a target="_blank" href="https://cloud.big.go.id/index.php/s/6EWfKc8NrqFNJfH">SOP Layanan KUGI</a>
                    </li>
                </ul>
            </li>

            <ul className="navigation-menu menu-right">
                <li className="mobile-none">
                    <Link
                    to="login"
                    style={this.state.active === "login" ? activeStyle : {}}
                    onClick={this._handleClick.bind(this, "login")}
                    >Login</Link>
                </li>
            </ul>
          </ul>
        )
      }else{
        return (
          <ul className="navigation-menu ">
            <li className="has-submenu ">
                <Link
                style={this.state.active === "" ? activeStyle : {}}
                onClick={this._handleClick.bind(this, "")}
                to="">
                  Beranda
                </Link>
            </li>
            <li className="has-submenu">
                <Link to="#"
                style={this.state.active === "kugi" ? activeStyle : {}}
                onClick={this._handleClick.bind(this, "kugi")}
                className="menu-arrowx"
                >KUGI</Link>
                <span className="menu-arrow"/>
                <ul className="submenu " >
                    <li>
                        <Link to="/kugi" onClick={this._handleClick.bind(this, "kugi")}>KUGI Versi 5.1</Link>
                    </li>

                    <li>
                        <Link to="pencarianbig" onClick={this._handleClick.bind(this, "kugi")}>Pencarian Data KUGI</Link>
                    </li>
                    <li>
                        <Link to="/unduhbukukugi" onClick={this._handleClick.bind(this, "tautan")}>Unduh Buku KUGI</Link>
                    </li>
                    <li>
                        <Link to="/unduhtemplatekugi" onClick={this._handleClick.bind(this, "tautan")}>Unduh Template KUGI </Link>
                    </li>
                    <li className="has-submenu">
                        <a target="_blank" href="https://gold.big.go.id/pencarianobjek">Pencarian Dengan Ontology</a>
                    </li>
                </ul>
            </li>


            <li className="has-submenu">
                <Link to="#"
                style={this.state.active === "tautan" ? activeStyle : {}}
                onClick={this._handleClick.bind(this, "tautan")}
                className="menu-arrowx"
                >Tautan & Juknis </Link>
                <span className="menu-arrow"/>
                <ul className="submenu " >

                    
                    <li className="has-submenu">
                        <a target="_blank" href="http://tanahair.indonesia.go.id/portal-web">Ina Geo Portal</a>
                    </li>
                    <li className="has-submenu">
                        <a target="_blank" href="https://kugi.ina-sdi.or.id/buku/Peraturan/se-6-2021-big.pdf">SE Ka.BIG 6/2021 - Pedoman Standar Data dan Struktur dan Format Baku Metadata</a>
                    </li>
                    <li className="has-submenu">
                        <a target="_blank" href="https://kugi.ina-sdi.or.id/buku/Panduan/Pedoman-Kerangka-Integrasi-Spasial-Statistik-tek.pdf">Pedoman Kerangka Integrasi Spasial Statistik (Teknologi)</a>
                    </li>                       
                    <li className="has-submenu">
                        <a target="_blank" href="http://pesta.bsn.go.id/produk/detail/9864-sniiso191102015">SNI ISO 19110 - 2015</a>
                    </li>
                     <li className="has-submenu">
                        <a target="_blank" href="https://jdih.big.go.id/hukumjdih/3155">PerBIG No 12 Tahun 2013</a>
                    </li>
                    <li className="has-submenu">
                        <a target="_blank" href="https://kugi.ina-sdi.or.id/buku/Panduan/Pedoman%20Penyusunan%20Data%20Sesuai%20KUGI%20QGIS%20dan%20ArcGIS.pdf">Juknis Penyusunan Data Sesuai KUGI</a>
                    </li>

                    <li className="has-submenu">
                        <a>Juknis Pembuatan Metadata Geospasial</a>
                        <ul className="submenu " >
                        <li className="has-submenu">
                        <a target="_blank" href="https://kugi.ina-sdi.or.id/buku/Panduan/Petunjuk%20Implementasi%20Pembuatan%20Metadata%20v6.pdf">Juknis Pembuatan Metadata Menggunakan ArcCatalog</a>
                        </li>
                        <li className="has-submenu">
                        <a target="_blank" href="https://kugi.ina-sdi.or.id/buku/Panduan/Petunjuk%20Implementasi%20Pembuatan%20Metadata%20v3CATMD.pdf">Juknis Pembuatan Metadata Menggunakan CatMDEdit</a>
                        </li>
                        </ul>
                    </li>
                    <li className="has-submenu">
                        <a target="_blank" href="https://www.youtube.com/playlist?list=PLP-Vnnw3ny2ZrSrkcxG0ILMsXbPQbpAUp">Video Penyusunan Data Sesuai KUGI</a>
                    </li>
                    
                    <li className="has-submenu">
                        <a>Video Tutorial Pembuatan Metadata</a>
                        <ul className="submenu " >
                        <li className="has-submenu">
                        <a target="_blank" href="https://youtu.be/T4AdLS8O1ZE">Pengenalan Pentingnya Metadata Geospasial</a>
                        </li>
                        <li className="has-submenu">
                        <a target="_blank" href="https://www.youtube.com/watch?v=egrZwWeMBDo">Tutorial Pembuatan Metadata Menggunakan ArcCatalog</a>
                        </li>
                        <li className="has-submenu">
                        <a target="_blank" href="https://www.youtube.com/watch?v=tVjs2N9zVF8">Tutorial Pembuatan Metadata Menggunakan CatMDEdit</a>
                        </li>
                        </ul>
                    </li>
                </ul>
            </li>
            <li>
                <a href = "https://documenter.getpostman.com/view/11245272/Tz5ncdvS" target="_blank">Layanan API</a>
            </li>
           <li className="has-submenu">
                <Link to="#"
                style={this.state.active === "Standar Layanan" ? activeStyle : {}}
                onClick={this._handleClick.bind(this, "Standar Layanan")}
                className="menu-arrowx"
                >Standar Layanan</Link>
                <span className="menu-arrow"/>
                <ul className="submenu " >
                    <li className="has-submenu">
                        <a target="_blank" href="https://kugi.ina-sdi.or.id/tentang">Tentang Layanan KUGI</a>
                    </li>
                    <li className="has-submenu">
                        <a target="_blank" href="https://cloud.big.go.id/index.php/s/6EWfKc8NrqFNJfH">SOP Layanan KUGI</a>
                    </li>
                </ul>
            </li>

            <li className="has-submenu">
                <Link to="#"
                style={this.state.active === "update" ? activeStyle : {}}
                onClick={this._handleClick.bind(this, "update")}
                className="menu-arrowx"
                >Update Data  </Link>
                <span className="menu-arrow"></span>
                <ul className="submenu " >
                  <li className="has-submenu ">
                      <Link
                      style={this.state.active === "featurecatalog" ? activeStyle : {}}
                      onClick={this._handleClick.bind(this, "update")}
                      to="featurecatalog">
                        Edit Katalog
                      </Link>
                  </li>
                  <li className="has-submenu ">
                      <Link
                      style={this.state.active === "featuretype" ? activeStyle : {}}
                      onClick={this._handleClick.bind(this, "update")}
                      to="featuretype">
                        Edit Unsur
                      </Link>
                  </li>
                  <li className="has-submenu ">
                      <Link
                      style={this.state.active === "dictionary" ? activeStyle : {}}
                      onClick={this._handleClick.bind(this, "update")}
                      to="dictionary">
                       Kamus Istilah
                      </Link>
                  </li>
                  <li className="has-submenu ">
                      <Link
                      style={this.state.active === "data3d" ? activeStyle : {}}
                      onClick={this._handleClick.bind(this, "update")}
                      to="data3d">
                        3D Data
                      </Link>
                  </li>
                  <li className="has-submenu ">
                      <Link
                      style={this.state.active === "cms" ? activeStyle : {}}
                      onClick={this._handleClick.bind(this, "update")}
                      to="cms">
                        CMS
                      </Link>
                  </li>
                  <li className="has-submenu ">
                      <Link
                      style={this.state.active === "cms" ? activeStyle : {}}
                      onClick={this._handleClick.bind(this, "update")}
                      to="generaterdf">
                        Generate RDF
                      </Link>
                  </li>
                </ul>
            </li>




            <ul className="navigation-menu menu-right">

                <li className="mobile-none">
                    <Link
                    to="login"
                    style={this.state.active === "login" ? activeStyle : {}}

                    onClick={this._handleClickLogout.bind(this, "login")}
                    >Logout</Link>
                </li>
            </ul>
          </ul>
        )
      }

    }


    render(){
        const activeStyle = { color: '#ffffff' };
        return(
            <AUX>
        <header id="topnav" className="defaultscroll sticky fixed-top">
        <div className="container">
        {/*<div>
            <Link to="index_1" className="logo">
                KUGI
            </Link>
        </div>*/}
        <div className="menu-extras">
            <div className="menu-item">
                <Link to="#" className="navbar-toggle">
                    <div className="lines">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </Link>
            </div>
        </div>
        <div id="navigation">
          {this.renderLogin()}
        </div>
    </div>
</header>




            </AUX>
        );
    }
}

const mapStatetoProps = state => {

    return {
        userID: state.userID
    };
}


export default connect(mapStatetoProps, {pushUserId})(Header);
